import React from "react";
import { useState } from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import { PrimaryButton as PrimaryButtonBase } from "components/misc/Buttons.js";
import MessageAnimation from "demos/MessageAnimation";

const Form = tw.form`mt-8  text-sm flex flex-col max-w-sm mx-auto md:mx-0`
const Input = tw.input`pl-2 mt-6 first:mt-0 border-b-2 py-3 focus:outline-none font-medium transition duration-300 hocus:border-primary-500 bg-transparent border-b-gray-500`
const Textarea = styled(Input).attrs({as: "textarea"})`
  ${tw`h-24`}
`

const SubmitButton = tw(PrimaryButtonBase)`inline-block mt-8`

const FooterForm = ({
  submitButtonText = "Envoyer",
  formAction = "#",
  formMethod = "POST",
  children
}


) => {

  const [hasSentMessage, setHasSentMessage] = useState(false);
  
  function handleSubmit(e) {
  e.preventDefault();
  const {nom, prénom, message, numéro} = e.target;

  
    fetch("https://formsubmit.co/ajax/contact@impots-reduc.fr", {
    method: "POST",
    headers: { 
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    },
    body: JSON.stringify({
        "Nom": nom.value,
        "Prénom": prénom.value,
        "Message": message.value,
        "Numéro de téléphone": numéro.value
    })
  })
    .then(response => response.json())
    .then(data => console.log(data))
    .catch(error => console.log(error));

  // trigger event for google tags tracking
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    'event': 'footer_form_submission'
  });

  setHasSentMessage(true);

  }
    return <>
      {!hasSentMessage && <Form action={formAction} method={formMethod} onSubmit={handleSubmit}>
          {children}
          <Input type="text" name="nom" placeholder="Nom" />
          <Input type="text" name="prénom" placeholder="Prénom" />
          <Textarea name="message" placeholder="Quelle est votre demande ?" />
          <Input type="text" name="numéro" placeholder="A quel numéro vous joindre ?" />
          <SubmitButton type="submit">{submitButtonText}</SubmitButton>
      </Form>}
        <MessageAnimation 
              message="Message reçu ! Merci de nous avoir contacté "
              hasSentMessage={hasSentMessage}
          />
    </>
    
}

export default FooterForm;